import { Alert } from "@mui/material";
import { PortalBanner } from "interfaces/PortalBanner";
import React, { FC, memo } from "react";

export type BannerBoxProps = {
  banner: PortalBanner;
};

export const BannerBox: FC<BannerBoxProps> = memo(({ banner }) => (
  <Alert severity={banner.typeText?.toLowerCase() as "error" | "warning" | "info" | "success" || "info"} variant="standard">
    <div dangerouslySetInnerHTML={{ __html: banner.body }} />
  </Alert>
));
